import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text, Icon } from '../Elements';

import classes from './ClearButton.module.scss';

const ClearButton = ({ onClick, numberОfFilters, className }) => {
  const { t } = useTranslation(['activity']);

  return (
    <div
      className={cn(
        classes.buttonWrap,
        numberОfFilters % 3 === 0 && classes.marginMin,
        numberОfFilters % 4 === 0 && classes.marginMax,
        className
      )}
    >
      <button className={classes.button} onClick={onClick}>
        <Icon size="16px" icon="close" className={classes.button_icon} />
        <Text className={classes.button_text} weight="m" size={6}>
          {t('activity:buttons.CLEAR_ALL')}
        </Text>
      </button>
    </div>
  );
};

ClearButton.propTypes = {
  onClick: PropTypes.func,
  numberОfFilters: PropTypes.number,
  className: PropTypes.string
};

export default ClearButton;
